export const serverRegions = {
  EU: {
    country: "Europe",
    code: "EU",
    api: process.env.PRODUCT_SIGNUP_API_EU,
    srcParam: "euserv",
  },
  US: {
    country: "United States",
    code: "US",
    api: process.env.PRODUCT_SIGNUP_API_US,
    srcParam: "usserv",
  },
}

export const pricingPlanOptions = {
  "Managed Service Provider": {
    plan: "Super",
    name: "Managed Service Provider",
    hubspotValue: "MSP",
  },
  "Part of a company’s IT Team": {
    plan: "Standard-RMM",
    name: "Part of a company’s IT Team",
    hubspotValue: "Internal IT",
  },
  Others: {
    plan: "Super",
    name: "Others",
    hubspotValue: "Others",
  },
}

export const productType = {
  MSP: {
    product: "MSP",
    name: "MSP",
    buttonName: "Managed Service Provider",
    hubspotValue: "MSP",
    description: "How many technicians are on your team?",
    errorMessage: "please select the technician count.",
    category: ["1-2", "3-5", "6-10", "11-15", "16-25", "26-50", "50+"],
    tooltipMessage:
      "If you provide IT services to other companies or organizations as an external service provider.",
  },
  IT: {
    product: "IT",
    name: "IT",
    buttonName: "Part of an IT Team",
    hubspotValue: "Internal IT",
    description: "How many employees do you have?",
    errorMessage: "please select the device count.",
    category: ["1-50", "51-100", "101-250", "251-500", "501-1000", "1001+"],
    tooltipMessage:
      "If you work as part of an in-house IT team managing technology and systems for your own organization.",
  },
  // Others: {
  //   product: "MSP",
  //   name: "Others",
  //   hubspotValue: "Others",
  // },
}

export const summaryPoints = [
  { "My Tickets Due Today": "2" },
  { Endpoints: "3" },
  { "All Patches": "10" },
  { MyTickets: "7" },
  { "Tickets I'm Following": "1" },
  { "Unassigned Tickets": "0" },
]

export const ITPricingCurrency = {
  AUD: {
    monthly: [2.4, 2.2, 2.0, 1.8],
    yearly: [2.1, 1.9, 1.7, 1.5],
    monthlyStr: ["2.40", "2.20", "2.00", "1.80"],
    yearlyStr: ["2.10", "1.90", "1.70", "1.50"],
    symbol: "$",
  },
  GBP: {
    monthly: [1.3, 1.2, 1.1, 1.0],
    yearly: [1.1, 1.0, 0.9, 0.8],
    monthlyStr: ["1.30", "1.20", "1.10", "1.00"],
    yearlyStr: ["1.10", "1.00", "0.90", "0.80"],
    symbol: "£",
  },
  EURO: {
    monthly: [1.5, 1.4, 1.3, 1.2],
    yearly: [1.3, 1.2, 1.1, 1.0],
    monthlyStr: ["1.50", "1.40", "1.30", "1.20"],
    yearlyStr: ["1.30", "1.20", "1.10", "1.00"],
    symbol: "€",
  },
  USD: {
    monthly: [1.5, 1.4, 1.3, 1.2],
    yearly: [1.3, 1.2, 1.1, 1.0],
    monthlyStr: ["1.50", "1.40", "1.30", "1.20"],
    yearlyStr: ["1.30", "1.20", "1.10", "1.00"],
    symbol: "$",
  },
}

export const ITPricingFeaturesOne = [
  {
    name: "SERVICE DESK",
    features: [
      {
        feature: "Ticketing - Incident & Request Management",
        available: "yes",
      },
      {
        feature: "Email - Support Channel",
        available: "yes",
      },
      {
        feature: "SLA Management",
        available: "yes",
      },
      {
        feature: "Tasks",
        available: "yes",
      },
      {
        feature: "Service Portal",
        available: "yes",
      },
      {
        feature: "Ticket And Reply Templates",
        available: "yes",
      },
      {
        feature: "Email Notifications",
        available: "yes",
      },
      {
        feature: "Audit Log",
        available: "yes",
      },
      {
        feature: "Custom Ticket Views",
        available: "yes",
      },
      {
        feature: "Custom Ticket Fields",
        available: "yes",
      },
      {
        feature: "Employee SSO",
        available: "yes",
      },
      {
        feature: "Satisfaction Survey Report",
        available: "yes",
      },
      {
        feature: "Ticket Custom Fields",
        available: "yes",
      },
      {
        feature: "Custom Roles",
        available: "yes",
      },
      {
        feature: "Custom Mail Servers",
        available: "yes",
      },
      {
        feature: "Multiple Mailbox",
        available: "yes",
      },
      {
        feature: "In-app Notifications",
        available: "yes",
      },
      {
        feature: "Side Conversations",
        available: "yes",
      },
      {
        feature: "Ticket & Task Templates",
        available: "yes",
      },
      {
        feature: "Technician Timesheets",
        available: "yes",
      },
      {
        feature: "Manager Timesheets",
        available: "yes",
      },
      {
        feature: "Agent Collision",
        available: "yes",
      },
      {
        feature: "Round Robin Ticket Assignment",
        available: "yes",
      },
      {
        feature: "Load-based Ticket Assignment",
        available: "yes",
      },
      {
        feature: "Scheduling",
        available: "yes",
      },
      {
        feature: "Chat",
        available: "yes",
      },
    ],
  },
  {
    name: "REAL-TIME ALERT MANAGEMENT",
    features: [
      {
        feature: "Manually Configure Alerts",
        available: "yes",
      },
    ],
  },
  {
    name: "MAC SPECIFIC",
    features: [
      {
        feature: "Automatic Approval Configurations",
        available: "yes",
      },
      {
        feature: "Scheduling Automation",
        available: "yes",
      },
    ],
  },
  {
    name: "AI",
    features: [
      {
        feature: "Ticket Summarization",
        available: "yes",
      },
      {
        feature: "Smart Worklog Formatting for Technicians",
        available: "yes",
      },
      {
        feature: "Smart Worklog Summaries",
        available: "yes",
      },
      {
        feature: "AI Prompt Builder & Rephrase",
        available: "yes",
      },
      // {
      //   feature: "Similar Tickets And Suggested Solutions",
      //   available: "yes",
      // },
      {
        feature: "Script Generation",
        available: "yes",
      },
      {
        feature: "Intelligent Alerting",
        available: "yes",
      },
    ],
  },
  {
    name: "KNOWLEDGE BASE",
    features: [
      {
        feature: "Rich text editor",
        available: "yes",
      },
      {
        feature: "Convert tickets into an article",
        available: "yes",
      },
      {
        feature: "Insert article into a ticket",
        available: "yes",
      },
      {
        feature: "Deflect tickets",
        available: "yes",
      },
    ],
  },
]
export const ITPricingFeaturesTwo = [
  {
    name: "PROJECT MANAGEMENT",
    features: [
      {
        feature: "Project Templates",
        available: "yes",
      },
      {
        feature: "Collaboration",
        available: "yes",
      },
      {
        feature: "Milestones",
        available: "yes",
      },
    ],
  },
  {
    name: "AUTOMATIONS",
    features: [
      {
        feature: "Unified Runbooks",
        available: "yes",
      },
      {
        feature: "Event Triggers",
        available: "yes",
      },
      {
        feature: "Time Triggers",
        available: "yes",
      },
      {
        feature: "Ticket Scheduler",
        available: "yes",
      },
      {
        feature: "Scripting",
        available: "yes",
      },
    ],
  },
  {
    name: "ORGANIZATION MANAGEMENT",
    features: [
      {
        feature: "Organization-Level Insights",
        available: "yes",
      },
      {
        feature: "Site Insights",
        available: "yes",
      },
      {
        feature: "Department Insights",
        available: "yes",
      },
    ],
  },
  {
    name: "REPORTS",
    features: [
      {
        feature: "Default Dashboards",
        available: "yes",
      },
      {
        feature: "PDF Reports",
        available: "yes",
      },
      {
        feature: "Share & Schedule Reports",
        available: "yes",
      },
      {
        feature: "Custom Dashboard",
        available: "yes",
      },
      {
        feature: "Data Reports",
        available: "yes",
      },
    ],
  },
  {
    name: "ASSET MANAGEMENT",
    features: [
      {
        feature: "Windows, MacOS, Linux",
        available: "yes",
      },
    ],
  },
  {
    name: "SOFTWARE MANAGEMENT",
    features: [
      {
        feature: "Scheduling Automation",
        available: "yes",
      },
      {
        feature: "Reboot Automations",
        available: "yes",
      },
      {
        feature: "New Asset Onboarding",
        available: "yes",
      },
      // {
      //   feature: "Software Management - Custom Repository",
      //   available: "yes",
      // },
    ],
  },
  {
    name: "IT DOCUMENTATION",
    features: [
      {
        feature: "Document Creation",
        available: "yes",
      },
    ],
  },
  {
    name: "NETWORK MONITORING",
    features: [
      {
        feature: "Convert endpoints to probes",
        available: "yes",
      },
      {
        feature: "Network discovery",
        available: "yes",
      },
      {
        feature: "Real-time insights",
        available: "yes",
      },
      {
        feature: "Network device alerting",
        available: "yes",
      },
      {
        feature: "ICMP monitoring",
        available: "yes",
      },
    ],
  },
]
export const ITPricingFeaturesThree = [
  {
    name: "INTEGRATIONS",
    features: [
      {
        feature: "Splashtop",
        available: "yes",
      },
      {
        feature: "Teamviewer",
        available: "yes",
      },
      {
        feature: "ConnectWise Control",
        available: "yes",
      },
      {
        feature: "Microsoft Entra ID (Azure AD)",
        available: "yes",
      },
      {
        feature: "Microsoft Outlook Calendar",
        available: "yes",
      },
      {
        feature: "Bitdefender",
        available: "yes",
      },
      {
        feature: "Sentinelone",
        available: "yes",
      },
      {
        feature: "ISL Online",
        available: "yes",
      },
      {
        feature: "ESET",
        available: "coming soon",
      },
      {
        feature: "Emsisoft",
        available: "coming soon",
      },

      {
        feature: "Webroot",
        available: "coming soon",
      },
      {
        feature: "Acronis",
        available: "coming soon",
      },
    ],
  },
  {
    name: "REMOTE TROUBLESHOOTING",
    features: [
      {
        feature: "Splashtop",
        available: "yes",
      },
      {
        feature: "Teamviewer BYOL",
        available: "yes",
      },
      {
        feature: "Screenconnect BYOL",
        available: "yes",
      },
      {
        feature: "File Explorer",
        available: "yes",
      },
      {
        feature: "Registry Editor",
        available: "yes",
      },
      {
        feature: "Remote Event Logs",
        available: "yes",
      },
    ],
  },
  {
    name: "PATCH MANAGEMENT",
    features: [
      {
        feature: "Hierarchical Policy Management",
        available: "yes",
      },
      {
        feature: "Advanced Policy Management",
        available: "yes",
      },
      {
        feature: "Disabling Local OS Manager",
        available: "yes",
      },
      {
        feature: "Automatic Approval Configurations",
        available: "yes",
      },
      {
        feature: "Scheduling Automation",
        available: "yes",
      },
      {
        feature: "Reboot Automations",
        available: "yes",
      },
      {
        feature: "New Asset Onboarding",
        available: "yes",
      },
      {
        feature: "Enable Wake on LAN",
        available: "yes",
      },
      {
        feature: "Patch Scan Schedule",
        available: "yes",
      },
      {
        feature: "Patch Installation Window",
        available: "yes",
      },
      {
        feature: "Deferring Patch Deployment",
        available: "yes",
      },
      {
        feature: "Maintenance Mode",
        available: "comming soon",
      },
      {
        feature: "Patch Schedule Notification Report",
        available: "comming soon",
      },
    ],
  },
  {
    name: "CUSTOMIZATIONS AND OTHERS",
    features: [
      {
        feature: "Agent Branding",
        available: "yes",
      },
      {
        feature: "Custom Asset Types",
        available: "yes",
      },
      {
        feature: "Agent Uninstall Protection",
        available: "yes",
      },
      {
        feature: "Advanced Asset Views Builder",
        available: "comming soon",
      },
      {
        feature: "Advanced Agent Customization",
        available: "comming soon",
      },
    ],
  },
]
